// Do not edit this file directly, it is generated by tools/check-missing-images.ts
export const CONFIGURATOR_IDS_TO_SKIP = [
  "8751011001",
  "8751011206",
  "8751016700",
  "8751016701",
  "8751018100",
  "8755326601",
  "8755911000",
  "8755911200",
  "8755911300",
  "8755937301",
  "8755959300",
  "8755959400",
  "8755969400",
  "8756911000",
  "8756911200",
  "8756911300",
  "8756937301",
  "8756959300",
  "8756959400",
  "8756968501",
  "8756969400",
  "8757911000",
  "8757911200",
  "8757911300",
  "8757937301",
  "8757959300",
  "8757959400",
  "8757969400",
  "8751011001",
  "8751011206",
  "8751016700",
  "8751016701",
  "8751018100",
  "8755326601",
  "8755911000",
  "8755911200",
  "8755911300",
  "8755937301",
  "8755959300",
  "8755959400",
  "8755969400",
  "8756911000",
  "8756911200",
  "8756911300",
  "8756937301",
  "8756959300",
  "8756959400",
  "8756968501",
  "8756969400",
  "8757911000",
  "8757911200",
  "8757911300",
  "8757937301",
  "8757959300",
  "8757959400",
  "8757969400",
  "8751013200",
  "8757139100",
  "8751013200",
  "8757139100",
  "8751013004",
  "8751013010",
  "8751013004",
  "8751013010",
  "8755932000",
  "8755936000",
]
